// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"v- y5","ribbon":"v_ zc","title":"wa y7","year":"wb y8","genres":"wc zb","duration":"wd","buttonWrapper":"we y9","button":"wf y-","price":"wh","upperParts":"wi"};